var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesforceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 69,
    viewBox: "0 0 100 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6138 7.52518C44.8386 4.21357 49.3283 2.15984 54.2935 2.15984C60.8957 2.15984 66.6547 5.78758 69.7203 11.175C72.3868 10.0012 75.3358 9.349 78.4396 9.349C90.3456 9.349 100 18.9478 100 30.786C100 42.6243 90.3478 52.2253 78.4396 52.2253C76.9864 52.2253 75.5668 52.0794 74.1921 51.8075C71.492 56.556 66.3452 59.7637 60.436 59.7637C57.9646 59.7637 55.6256 59.2022 53.5422 58.1986C50.8062 64.5477 44.426 69 36.9918 69C29.5575 69 22.6503 64.1719 20.1184 57.3983C19.0128 57.6282 17.8646 57.7498 16.6872 57.7498C7.47236 57.7498 0 50.3064 0 41.1254C0 34.9709 3.35494 29.5989 8.34473 26.725C7.31762 24.3949 6.748 21.8239 6.748 19.1202C6.748 8.562 15.4448 0 26.169 0C32.4662 0 38.0637 2.95127 41.6138 7.52518Z",
    fill: "#139CD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforceLogo);
export default __webpack_public_path__ + "static/media/salesforce_logo.6ed861b7dc91f215545bdbf450ea0800.svg";
export { ForwardRef as ReactComponent };